import { config } from 'data';
import { payoutService } from 'services';
import { useQuery } from 'hooks';
import { PayoutsParams } from 'types/services';

const usePayoutsQuery = (params?: PayoutsParams) => useQuery({
  queryKey: [config.PAYOUTS_QUERY_KEY, params],
  queryFn: () => payoutService.getPayouts(params),
});

export default usePayoutsQuery;
